import { render, staticRenderFns } from "./PolicyTable.vue?vue&type=template&id=1b451bd2&scoped=true&"
import script from "./PolicyTable.vue?vue&type=script&lang=js&"
export * from "./PolicyTable.vue?vue&type=script&lang=js&"
import style0 from "./PolicyTable.vue?vue&type=style&index=0&id=1b451bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b451bd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
